import React, { Component } from 'react';
import Loader from '../../../container/Loader';
import { Form } from 'reactstrap';
import Swal from 'sweetalert2';
import MaskedInput from 'react-maskedinput';
import { MDBContainer, MDBTabPane, MDBTabContent, MDBNav, MDBNavItem, MDBNavLink } from "mdbreact";
import { getId, getToken, getClient } from "../../../services/auth";
import api from "../../../services/api";
import ApiCep from "../../../services/cep";

class FormClient extends Component {

    constructor(props) {
        super(props)
        this.state = { 
          loading: false,
          activeItem: "1",
          errors: {},
          id: 0,
          cnpj: '',
          razao_social: '',
          inscricao_estadual: '',
          inscricao_municipal: '',
          site: '',
          telefone1: '',
          telefone2: '',
          celular: '',
          email: '',
          cep: '',
          logradouro: '',
          numero: '',
          complemento: '',
          bairro: '',
          cidade: '',
          estado: '',
          contato_cep: '',
          contato_tipo: '',
          contato_logradouro: '',
          contato_numero: '',
          contato_complemento: '',
          contato_bairro: '',
          contato_cidade: '',
          contato_uf: '',
          status: '',
          ordem: '',
          listDocumento: [],
          documento: String,
       }
        this.handleChange = this.handleChange.bind(this);
        this.handleFile = this.handleFile.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
      }

  getCep(e) {
    const cep = e.target.value;
    ApiCep.SearchCep(cep)
      .then(res => {
        let logradouro = res.data.logradouro;
        let bairro = res.data.bairro;
        let cidade = res.data.localidade;
        let uf = res.data.uf;

        this.setState({ logradouro: logradouro, bairro: bairro, cidade: cidade, estado: uf })
      }).catch(err => console.log(err));
  }

  getContatoCep(e) {
    const cep = e.target.value;
    ApiCep.SearchCep(cep)
      .then(res => {
        let logradouro = res.data.logradouro;
        let bairro = res.data.bairro;
        let cidade = res.data.localidade;
        let uf = res.data.uf;

        this.setState({ contato_logradouro: logradouro, contato_bairro: bairro, contato_cidade: cidade, contato_uf: uf })
      }).catch(err => console.log(err));
  }

  async getDocumento(id) {
    const token = getToken();
    this.setState({loading: true});

    const response = await api.get(`juridica/documento/${id}`, { headers: { token } })
    this.setState({listDocumento: response.data, ordem: response.data.length, loading: false})
  }

  toggleTab = tab => e => {
    if (this.state.activeItem !== tab) {
      this.setState({
        activeItem: tab
      });
    }
  };

  handleChange(e){
    const target = e.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }
  
  handleFile(file)
    {
      this.setState({ 
        documento: file[0],
      })
    }

  componentDidMount() {

    if (this.props.edit) {
      this.setState({loading: true});
      const id  = this.props.juridicas.id;
      const token = getToken();
  
      api.get('juridica/' + id, {
        headers: { token },
      })
      .then(response => {
        const { id, cnpj, razao_social, inscricao_estadual, inscricao_municipal, site, telefone1, telefone2, celular, email, cep, logradouro, numero, complemento, bairro, cidade, estado, status } = response.data;
        const { contato_cep, contato_tipo, contato_logradouro, contato_numero, contato_complemento, contato_bairro, contato_cidade, contato_uf } = response.data;
        this.setState({ contato_cep, contato_tipo, contato_logradouro, contato_numero, contato_complemento, contato_bairro, contato_cidade, contato_uf});
        this.setState({ id, cnpj, razao_social, inscricao_estadual, inscricao_municipal, site, telefone1, telefone2, celular, email, cep, logradouro, numero, complemento, bairro, cidade, estado, status, loading: false});
      })
      .catch(function (error) {
        console.log(error);
      })
      
      this.getDocumento(id)
    }  
  }

  handleSubmit(e) {
    e.preventDefault();

    if(this.validate()){

    const fd = new FormData();
    fd.append('id', this.state.id);
    fd.append('cnpj', this.state.cnpj);
    fd.append('razao_social', this.state.razao_social);
    fd.append('inscricao_estadual', this.state.inscricao_estadual);
    fd.append('inscricao_municipal', this.state.inscricao_municipal);
    fd.append('site', this.state.site);
    fd.append('telefone1', this.state.telefone1);
    fd.append('telefone2', this.state.telefone2);
    fd.append('celular', this.state.celular);
    fd.append('email', this.state.email);
    fd.append('cep', this.state.cep);
    fd.append('logradouro', this.state.logradouro);
    fd.append('numero', this.state.numero);
    fd.append('complemento', this.state.complemento);
    fd.append('bairro', this.state.bairro);
    fd.append('cidade', this.state.cidade);
    fd.append('estado', this.state.estado);
    fd.append('contato_cep', this.state.contato_cep);
    fd.append('contato_tipo', this.state.contato_tipo);
    fd.append('contato_logradouro', this.state.contato_logradouro);
    fd.append('contato_numero', this.state.contato_numero);
    fd.append('contato_complemento', this.state.contato_complemento);
    fd.append('contato_bairro', this.state.contato_bairro);
    fd.append('contato_cidade', this.state.contato_cidade);
    fd.append('contato_uf', this.state.contato_uf);
    fd.append('status', this.state.status);
    fd.append('documento', this.state.documento);
    fd.append('id_logado', getId());
    fd.append('id_cliente', getClient());
    fd.append('ordem', this.state.ordem + 1);
      
    const token = getToken();
    api.post('juridica', fd,
    { headers: { token }} )
    .then((response) => {
      Swal.fire({
        title: response.data.success ? 'Juridica cadastrado com sucesso' : 'Ocorreu um erro ao salvar, tente novamente.',
        icon: response.data.success ? 'success': 'warning',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'OK',
      }).then((result) => {
        if (result.value) {
          window.location.reload();
        }
      })      
    });    
    }  
  }

  validate(){
    let cnpj = this.state.cnpj;

    let errors = {};
    let isValid = true;
    
    if (!cnpj) {
      isValid = false;
      errors["nome"] = "Por favor, insira seu CNPJ.";
    }

    this.setState({
      errors: errors
    });

    return isValid;
}

  render() {
    const isLoggedIn = this.state.loading;
    let closeBtn = <button type="button" className="btn btn-danger" onClick={this.props.toggle} data-dismiss="modal">Fechar</button>
    const files = this.state.listDocumento.map(file => {
      return (
        <div key={file.id} className="col-sm-6" style={{border: '1px solid rgba(0,0,0,.125)', borderRadius: '.25rem'}}>
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">{file.descricao}</h5>
              <p className="card-text">{file.nome}</p>
              <a href={file.diretorio} target="_blank" rel="noopener noreferrer" className="btn btn-primary">Visualizar Documento</a>
            </div>
          </div>
        </div>
      )
    })
    return (
      <Form style={{ marginBottom: isLoggedIn ? '100px' : ''}} onSubmit={this.handleSubmit}>

        {isLoggedIn ? <Loader /> : 

            <MDBContainer>
              <MDBNav className="nav-tabs mt-5">
                  <>
                    <MDBNavItem>
                      <MDBNavLink link to="#" active={this.state.activeItem === "1"} onClick={this.toggleTab("1")} role="tab" >
                      Endereço/Contato
                      </MDBNavLink>
                    </MDBNavItem>
                    <MDBNavItem>
                      <MDBNavLink link to="#" active={this.state.activeItem === "2"} onClick={this.toggleTab("2")} role="tab" >
                      Dados Cadastrais
                    </MDBNavLink>
                    </MDBNavItem>
                    <MDBNavItem>
                      <MDBNavLink link to="#" active={this.state.activeItem === "3"} onClick={this.toggleTab("3")} role="tab" >
                        Módulos
                    </MDBNavLink>
                    </MDBNavItem>
                    <MDBNavItem>
                      <MDBNavLink link to="#" active={this.state.activeItem === "4"} onClick={this.toggleTab("4")} role="tab" >
                        Serviços
                    </MDBNavLink>
                    </MDBNavItem>
                    <MDBNavItem>
                      <MDBNavLink link to="#" active={this.state.activeItem === "5"} onClick={this.toggleTab("5")} role="tab" >
                        Documentação
                    </MDBNavLink>
                    </MDBNavItem>
                  </>

              </MDBNav>
              <MDBTabContent activeItem={this.state.activeItem} >
              <MDBTabPane tabId="1" role="tabpanel">
              <div className="cadastro-wrapper" style={{ backgroundColor: 'white', border: 0 }}>
                  <header >Endereço/Contato</header>
                  <div className="dados-wrapper" >
                    <div className="row">
                    <div className="col-sm-12 col-md-6 col-lg-2">
                        <div className="form-group">
                          <label htmlFor="contato_cep" className="labelB">CEP: <span style={{ color: 'red' }}>*</span></label>
                          <MaskedInput mask="11111-111" type="text" name="contato_cep" onBlur={this.getContatoCep.bind(this)}
                            value={this.state.contato_cep === null ? '' : this.state.contato_cep}
                            className="form-control"
                            placeholder="CEP"
                            onChange={this.handleChange.bind(this)} required
                          />
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-6 col-lg-4">
                        <div className="form-group">
                          <label htmlFor="contato_tipo" className="labelB">Tipo Logradouro: <span style={{ color: 'red' }}>*</span></label>
                          <select className="form-control custom-select" value={this.state.contato_tipo === null ? '' : this.state.contato_tipo}
                            name="contato_tipo" onChange={this.handleChange.bind(this)} required>
                            <option value="" >Selecione</option>
                            <option value="Alameda" >Alameda</option>
                            <option value="Área" >Área</option>
                            <option value="Avenida" >Avenida</option>
                            <option value="Campo" >Campo</option>
                            <option value="Chácara" >Chácara</option>
                            <option value="Colônia" >Colônia</option>
                            <option value="Condomínio" >Condomínio</option>
                            <option value="Conjunto" >Conjunto</option>
                            <option value="Distrito" >Distrito</option>
                            <option value="Esplanada" >Esplanada</option>
                            <option value="Estação" >Estação</option>
                            <option value="Estrada" >Estrada</option>
                            <option value="Favela" >Favela</option>
                            <option value="Feira" >Feira</option>
                            <option value="Jardim" >Jardim</option>
                            <option value="Ladeira" >Ladeira</option>
                            <option value="Lago" >Lago</option>
                            <option value="Lagoa" >Lagoa</option>
                            <option value="Largo" >Largo</option>
                            <option value="Loteamento" >Loteamento</option>
                            <option value="Morro" >Morro</option>
                            <option value="Núcleo" >Núcleo</option>
                            <option value="Parque" >Parque</option>
                            <option value="Passarela" >Passarela</option>
                            <option value="Pátio" >Pátio</option>
                            <option value="Praça" >Praça</option>
                            <option value="Quadra" >Quadra</option>
                            <option value="Recanto" >Recanto</option>
                            <option value="Residencial" >Residencial</option>
                            <option value="Rodovia" >Rodovia</option>
                            <option value="Rua" >Rua</option>
                            <option value="Setor" >Setor</option>
                            <option value="Sítio" >Sítio</option>
                            <option value="Travessa" >Travessa</option>
                            <option value="Trecho" >Trecho</option>
                            <option value="Trevo" >Trevo</option>
                            <option value="Vale" >Vale</option>
                            <option value="Vereda" >Vereda</option>
                            <option value="Via" >Via</option>
                            <option value="Viaduto" >Viaduto</option>
                            <option value="Viela" >Viela</option>
                            <option value="Vila" >Vila</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-6 col-lg-4">
                        <div className="form-group">
                          <label htmlFor="contato_logradouro" className="labelB">Logradouro: <span style={{ color: 'red' }}>*</span></label>
                          <input type="text" name="contato_logradouro"
                            className="form-control"
                            placeholder="Logradouro" 
                            defaultValue={this.state.contato_logradouro === null ? '' : this.state.contato_logradouro}
                            onChange={this.handleChange.bind(this)} required
                            />
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-6 col-lg-2">
                        <div className="form-group">
                          <label htmlFor="contato_numero" className="labelB">Nº: <span style={{ color: 'red' }}>*</span></label>
                          <input type="text" name="contato_numero"
                            className="form-control" placeholder="Nº" 
                            defaultValue={this.state.contato_numero === null ? '' : this.state.contato_numero}
                            onChange={this.handleChange.bind(this)} required
                            />
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-6 col-lg-3">
                        <div className="form-group">
                          <label htmlFor="contato_complemento" className="labelB">Complemento: <span style={{ color: 'red' }}>*</span></label>
                          <input type="text" name="contato_complemento"
                            className="form-control"
                            placeholder="Complemento" 
                            defaultValue={this.state.contato_complemento === null ? '' : this.state.contato_complemento}
                            onChange={this.handleChange.bind(this)} required
                            />
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-6 col-lg-3">
                        <div className="form-group">
                          <label htmlFor="contato_bairro" className="labelB">Bairro: <span style={{ color: 'red' }}>*</span></label>
                          <input type="text" name="contato_bairro"
                            className="form-control"
                            placeholder="Bairro" 
                            defaultValue={this.state.contato_bairro === null ? '' : this.state.contato_bairro}
                            onChange={this.handleChange.bind(this)} required
                            />
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-6 col-lg-3">
                        <div className="form-group">
                          <label htmlFor="contato_cidade" className="labelB">Cidade: <span style={{ color: 'red' }}>*</span></label>
                          <input type="text" name="contato_cidade" defaultValue={this.state.contato_cidade}
                            className="form-control"
                            placeholder="Cidade" 
                            onChange={this.handleChange.bind(this)} required
                            />
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-6 col-lg-3">
                        <div className="form-group">
                          <label htmlFor="contato_uf" className="labelB">UF: <span style={{ color: 'red' }}>*</span></label>
                          <input type="text" name="contato_uf" defaultValue={this.state.contato_uf} required
                            className="form-control"
                            placeholder="Estado" 
                            onChange={this.handleChange.bind(this)}
                            />
                        </div>
                      </div>
                    </div>
              </div>
            </div>
                </MDBTabPane>
                <MDBTabPane tabId="2" role="tabpanel">
                <div className="cadastro-wrapper" style={{ backgroundColor: 'white', border: 0 }}>
                  <header >Dados do Jurídica</header>
                  <div className="dados-wrapper" >
                <div className="row">
                  <div className="col-sm-12 col-md-6 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="cnpj" className="labelB">CNPJ <span style={{ color: 'red' }}>*</span></label>
                      <MaskedInput mask="11.111.111/1111-11" type="text" name="cnpj" maxLength='14' value={this.state.cnpj === null ? '' : this.state.cnpj}
                        className="form-control"
                        placeholder="CNPJ"
                        onChange={this.handleChange.bind(this)} required
                      />
                      <small className="form-text text-danger"></small>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="razao_social" className="labelB">Razão Social</label>
                      <input type="text" name="razao_social" defaultValue={this.state.razao_social === null ? '' : this.state.razao_social}
                        className="form-control"
                        placeholder="Razão Social" 
                        onChange={this.handleChange.bind(this)} required
                        />
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="inscricao_estadual" className="labelB">Inscrição Estadual</label>
                      <input type="text" name="inscricao_estadual" defaultValue={this.state.inscricao_estadual === null ? '' : this.state.inscricao_estadual}
                        className="form-control"
                        placeholder="Inscrição Estadual" 
                        onChange={this.handleChange.bind(this)} required
                        />
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="inscricao_municipal" className="labelB">Inscrição Municipal</label>
                      <input type="text" name="inscricao_municipal" defaultValue={this.state.inscricao_municipal === null ? '' : this.state.inscricao_municipal}
                        className="form-control"
                        placeholder="Inscrição Municipal" 
                        onChange={this.handleChange.bind(this)} required
                        />
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="site" className="labelB">Site</label>
                      <input type="url" name="site" defaultValue={this.state.site === null ? '' : this.state.site}
                        className="form-control"
                        placeholder="Site" 
                        onChange={this.handleChange.bind(this)} required
                        />
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="telefone1" className="labelB">Telefone 1:</label>
                      <MaskedInput mask="(11) 11111-1111" type="text" name="telefone1" value={this.state.telefone1 === null ? '' : this.state.telefone1}
                        className="form-control"
                        placeholder="Telefone 2" 
                        onChange={this.handleChange.bind(this)} required
                        />                        
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="telefone2" className="labelB">Telefone 2:</label>
                      <MaskedInput mask="(11) 11111-1111" type="text" name="telefone2" value={this.state.telefone2 === null ? '' : this.state.telefone2}
                        className="form-control"
                        placeholder="Telefone 2" 
                        onChange={this.handleChange.bind(this)} required
                        />                        
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="celular" className="labelB">Celular:</label>
                      <MaskedInput mask="(11) 11111-1111" type="text" name="celular" value={this.state.celular === null ? '' : this.state.celular}
                        className="form-control"
                        placeholder="Celular"
                        onChange={this.handleChange.bind(this)} required
                      />
                      <small className="form-text text-danger"></small>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-6">
                    <div className="form-group">
                      <label htmlFor="email" className="labelB">E-mail <span style={{color: 'red'}}>*</span></label>
                      <input type="email" name="email" defaultValue={this.state.email === null ? '' : this.state.email}
                        className="form-control error"
                        placeholder="E-mail"
                        onChange={this.handleChange.bind(this)}
                      />
                      <small className="form-text text-danger"></small>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-6">
                    <div className="form-group">
                      <label htmlFor="status" className="labelB">Status <span style={{color: 'red'}}>*</span></label>
                      <select className="form-control custom-select" onChange={this.handleChange.bind(this)}
                        name="status" value={this.state.status === null ? '' : this.state.status} required>
                        <option value="" >Selecione</option>
                        <option value="0">Desativo</option>
                        <option value="1">Ativo</option>
                      </select>
                      <small className="form-text text-danger"></small>
                    </div>
                  </div>
                </div>
              </div>
                  <header>Endereço</header>
                  <div className="endereco-wrapper" >
                <div className="row">
                  <div className="col-sm-12 col-md-6 col-lg-2">
                    <div className="form-group">
                      <label htmlFor="cep" className="labelB">CEP: <span style={{ color: 'red' }}>*</span></label>
                      <MaskedInput mask="11111-111" type="text" name="cep" onBlur={this.getCep.bind(this)}
                        value={this.state.cep === null ? '' : this.state.cep}
                        className="form-control"
                        placeholder="CEP"
                        onChange={this.handleChange.bind(this)} required
                      />
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-8">
                    <div className="form-group">
                      <label htmlFor="logradouro" className="labelB">Logradouro: <span style={{ color: 'red' }}>*</span></label>
                      <input type="text" name="logradouro"
                        className="form-control"
                        placeholder="Logradouro" 
                        defaultValue={this.state.logradouro === null ? '' : this.state.logradouro}
                        onChange={this.handleChange.bind(this)} required
                        />
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-2">
                    <div className="form-group">
                      <label htmlFor="numero" className="labelB">Nº: <span style={{ color: 'red' }}>*</span></label>
                      <input type="text" name="numero"
                        className="form-control" placeholder="Nº" 
                        defaultValue={this.state.numero === null ? '' : this.state.numero}
                        onChange={this.handleChange.bind(this)} required
                        />
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-3">
                    <div className="form-group">
                      <label htmlFor="complemento" className="labelB">Complemento: <span style={{ color: 'red' }}>*</span></label>
                      <input type="text" name="complemento"
                        className="form-control"
                        placeholder="Complemento" 
                        defaultValue={this.state.complemento === null ? '' : this.state.complemento}
                        onChange={this.handleChange.bind(this)}
                        />
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-3">
                    <div className="form-group">
                      <label htmlFor="bairro" className="labelB">Bairro: <span style={{ color: 'red' }}>*</span></label>
                      <input type="text" name="bairro"
                        className="form-control"
                        placeholder="Bairro" 
                        defaultValue={this.state.bairro === null ? '' : this.state.bairro}
                        onChange={this.handleChange.bind(this)} required
                        />
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-3">
                    <div className="form-group">
                      <label htmlFor="cidade" className="labelB">Cidade: <span style={{ color: 'red' }}>*</span></label>
                      <input type="text" name="cidade" defaultValue={this.state.cidade}
                        className="form-control"
                        placeholder="Cidade" 
                        onChange={this.handleChange.bind(this)} required
                        />
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-3">
                    <div className="form-group">
                      <label htmlFor="uf" className="labelB">UF: <span style={{ color: 'red' }}>*</span></label>
                      <input type="text" name="cidade" defaultValue={this.state.estado} required
                        className="form-control"
                        placeholder="Estado" 
                        onChange={this.handleChange.bind(this)}
                        />
                    </div>
                  </div>
                </div>
              </div>
            </div>
                </MDBTabPane>
                <MDBTabPane tabId="3" role="tabpanel">
                  Permissões de Módulos
                </MDBTabPane>
                <MDBTabPane tabId="4" role="tabpanel">
                  Permissões de Serviços
                </MDBTabPane>
                <MDBTabPane tabId="5" role="tabpanel">
                <div className="cadastro-wrapper" style={{ backgroundColor: 'white', border: 0 }}>
                <header >Dados do Documentação</header>
                <div className="dados-wrapper" >
                <div className="row">
                  <div className="col-sm-12 col-md-6 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="documento" className="labelB">Documento <span style={{ color: 'red' }}>*</span></label>
                      <input className="form-control-plaintext" onChange={ (e) => this.handleFile(e.target.files) } type="file" id="documento" ref="documento" />
                      <small className="form-text text-danger"></small>
                    </div>
                  </div>
                  </div>
                  <div className="row" style={{marginLeft: '0', marginRight: '0'}}>{files}</div>
                  </div>
                  </div>
                </MDBTabPane>
              </MDBTabContent>
            </MDBContainer>
            }
            <div className="modal-footer" style={{marginTop: '15px'}}>
              {closeBtn}
              <button type="submit" className="btn btn-primary" style={{marginRight:'30px'}}><i className="fa fa-floppy-o" aria-hidden="true"></i> Salvar</button>
            </div>
      </Form>
    );
  }
}

export default FormClient